<template>
  <app-form class="app-container" v-bind="form" />
</template>

<script>
import appForm from '@/components/AppForm';
import models from '@/models';

export default {
  name: 'create',
  components: { appForm },
  data() {
    const form = models.business();
    return {
      form
    };
  }
};
</script>
